import { MiniTrendCard, Section, type SelectOption, SelectPill } from "./components"
import { type MiniTrendColumnData, trendsDateRangeOptions } from "./dashboardData"

import styles from "./index.module.scss"

type Props = {
  contractorOptions: SelectOption[]
  isContractorsLoading: boolean
  thermostatTrendOption: string
  customerTrendOption: string
  systemHealthTrendOption: string
  contractorId: string
  installationTrendColumns: MiniTrendColumnData[]
  customerTrendColumns: MiniTrendColumnData[]
  systemHealthTrendColumns: MiniTrendColumnData[]
  onThermostatTrendOptionChange: (option: string) => void
  onCustomerTrendOptionChange: (option: string) => void
  onSystemHealthTrendOptionChange: (option: string) => void
  onContractorChange: (option: string) => void
}

export const TrendsWidget = ({
  contractorOptions,
  isContractorsLoading,
  thermostatTrendOption,
  customerTrendOption,
  systemHealthTrendOption,
  contractorId,
  installationTrendColumns,
  customerTrendColumns,
  systemHealthTrendColumns,
  onThermostatTrendOptionChange,
  onCustomerTrendOptionChange,
  onSystemHealthTrendOptionChange,
  onContractorChange,
}: Props) => (
  <Section
    title="Trends"
    controls={
      <SelectPill
        options={contractorOptions}
        value={contractorId}
        disabled={isContractorsLoading}
        onChange={onContractorChange}
      />
    }
    className={styles.trendsSection}
  >
    <MiniTrendCard
      title="Installation & Thermostats"
      controls={
        <SelectPill
          options={trendsDateRangeOptions}
          value={thermostatTrendOption}
          onChange={onThermostatTrendOptionChange}
        />
      }
      columns={installationTrendColumns}
    />
    <MiniTrendCard
      title="Customers & Apps"
      controls={
        <SelectPill
          options={trendsDateRangeOptions}
          value={customerTrendOption}
          onChange={onCustomerTrendOptionChange}
        />
      }
      columns={customerTrendColumns}
    />
    <MiniTrendCard
      title="System Health"
      controls={
        <SelectPill
          options={trendsDateRangeOptions}
          value={systemHealthTrendOption}
          onChange={onSystemHealthTrendOptionChange}
        />
      }
      columns={systemHealthTrendColumns}
    />
  </Section>
)
